import { lazy, Suspense } from "react";
import ReactDOM from "react-dom";
import { MuiThemeProvider } from "@material-ui/core";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import "moment/locale/ru";
import "./sass/main.sass";
import * as Sentry from "@sentry/react";

import Moment from "react-moment";
import moment from "moment";
import MomentUtils from "@date-io/moment";

import store from "./store";
import { theme } from "./theme/theme";
import { App } from "./app";

moment.locale("ru");
moment.defaultFormat = "DD.MM.YYYY";
Moment.globalLocale = "ru";
Moment.globalFormat = "DD.MM.YYYY";

Sentry.init({
  dsn: "https://153bd1eb7b5d717a6fbc5048ccfe3e29@sentry.atoms.ru/10",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/owner\.alphapet\.ru/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  enabled: process.env.REACT_APP_SENTRY === "true",
});

const ErrorFallback = lazy(() => import("./pages/error-fallback"));

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <MuiThemeProvider theme={theme}>
        <ErrorBoundary
          fallbackRender={() => (
            <Suspense fallback="">
              <ErrorFallback />
            </Suspense>
          )}
        >
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <App />
          </MuiPickersUtilsProvider>
        </ErrorBoundary>
      </MuiThemeProvider>
    </BrowserRouter>
  </Provider>,

  document.getElementById("root")
);
